import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { Seo } from "@/components/Seo";

export default function PartnerLogin() {
  const [form, setForm] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const { partnerLogin } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await partnerLogin(form.email, form.password);
      toast.success("Welcome, partner");
      navigate("/partner/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid partner credentials");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-5" data-testid="partner-login-page">
      <Seo title="Partner Login" description="ERRAH partner portal." />
      <div className="w-full max-w-md">
        <Link to="/" className="flex justify-center mb-6"><img src="/errah-logo.png" alt="ERRAH — Style Your Space" className="h-28 w-auto object-contain" /></Link>
        <p className="text-center errah-label mb-10">Partner Portal</p>
        <form onSubmit={submit} className="space-y-4">
          <input required type="email" placeholder="Partner email" value={form.email} data-testid="partner-email"
            onChange={(e) => setForm({ ...form, email: e.target.value })} className="w-full bg-transparent border border-white/15 px-4 py-3 text-sm focus:border-[#C9A45C]" />
          <input required type="password" placeholder="Password" value={form.password} data-testid="partner-password"
            onChange={(e) => setForm({ ...form, password: e.target.value })} className="w-full bg-transparent border border-white/15 px-4 py-3 text-sm focus:border-[#C9A45C]" />
          <button type="submit" disabled={busy} data-testid="partner-submit" className="w-full bg-[#C9A45C] text-black py-3.5 text-sm font-semibold hover:bg-[#E4C987] transition-colors disabled:opacity-60">
            {busy ? "Please wait…" : "Partner sign in"}
          </button>
        </form>
        <p className="mt-8 text-center text-xs text-gray-600"><Link to="/login" className="text-[#C9A45C] hover:underline">Customer login</Link></p>
      </div>
    </div>
  );
}
